const { CONSTANTS } = require('../../config')
const { number } = require('./number')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {number|string} value
 * @param {string} country
 * @param {string} [locale]
 * @param {number} [decimals=2]
 * @returns {string}
 */
function currency (value, country, locale = '', decimals = 2) {
  if (!value && value !== 0) return ''

  const defaultLocale = CONSTANTS[country?.toUpperCase()]?.LOCALE
  const currency = CONSTANTS[country?.toUpperCase()]?.CURRENCY?.[locale || defaultLocale]?.currency ?? ''
  const format = CONSTANTS[country?.toUpperCase()]?.CURRENCY?.[locale || defaultLocale]?.format ?? ''
  const amount = number(value, country, locale, decimals)

  return format
    .replace('{amount}', amount)
    .replace('{currency}', currency)
}

module.exports = { currency }
